import rimg from '@pixelunion/rimg-shopify';
import Masonry from 'masonry-layout';
import themeUtils from '../themeUtils';

export default class MasonryGrid {
  constructor({ el, settings }) {
    this.el = el;
    this.layout = this.layout.bind(this);
    rimg.watch(this.el);

    const defaultSettings = {
      itemSelector: '[data-masonry-item]',
      columnWidth: '[data-masonry-sizer]',
      gutter: 0,
      percentPosition: false,
    };

    this.settings = themeUtils.extend(defaultSettings, settings);
    this.masonry = new Masonry(this.el, this.settings);
    this.layout();
    this.el.addEventListener('rimg:load', this.layout);
  }

  layout() {
    this.masonry.layout();
  }

  unload() {
    this.masonry.destroy();
    this.el.removeEventListener('rimg:load', this.layout);
  }
}
